import styled from 'styled-components';

export const FishWrapper = styled.span`
  display: block;
  color: #f3f39e;
  line-height: 1.5;
  margin: 0 auto;
  overflow: hidden;
`;
